import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteFromViolationListFailed, deleteFromViolationListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteFromViolationList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/violation-list`;
    const dataResponse = yield makeRequest(url, { ids: action.payload }, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deleteFromViolationListSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteFromViolationListFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteFromViolationListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
